<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md6 style="text-align: center">
                        <v-flex xs12 sm12 md12 d-inline-flex>
                            <v-flex xs2 sm2 md2 text-right  class="labelFont">
                                <v-label >影像</v-label>
                            </v-flex>
                            <v-flex xs10 sm10 md10 pl-2>

                                <img   :src="empImage" id="image1" :class="[ empImage!='' ? 'uerIcon' : 'noUerIcon']" ref="imgref" style=" border: 1px solid gray;min-width: 200px;
    max-width: 200px;">

                                <!-- pickPicPhoto('iptImage1','image1',25,25)-->
                                <input  class="custom-file-input" type="file" ref="fileref"  id="iptImage1" value="" @change="pickImage"  />

                                <v-btn  title="刪除影像" icon  @click.native.stop="deleteImgIcon"><!---->
                                    <v-icon  color="pink">mdi-delete</v-icon>
                                </v-btn>

                            </v-flex>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md6>

                        <v-flex xs12 sm12 md12 d-inline-flex>
                            <v-flex xs5 sm5 md6 text-right  class="labelFont">
                                <v-label >顯示順序</v-label>
                            </v-flex>
                            <v-flex xs7 sm7 md6 pl-2>
                                <v-text-field   v-model="displaySeq"  type="number"  clearable></v-text-field>
                            </v-flex>
                        </v-flex>

                        <v-flex row wrap xs12 sm12 md12 >
                            <v-flex xs5 sm5 md6 text-right  class="labelFont">
                                <v-label >員工編號</v-label>
                            </v-flex>
                            <v-flex xs7 sm7 md6 pl-2>
                                <!--:disabled="this.editIndex!=-1"-->
                                <v-text-field  :disabled="this.editIndex!=-1" v-model="empNo" @keyup.enter="getDoctorInfo"  clearable></v-text-field>
                            </v-flex>
                        </v-flex>

                        <v-flex row wrap xs12 sm12 md12>
                            <v-flex xs5 sm5 md6 text-right  class="labelFont">
                                <v-label >員工姓名</v-label>
                            </v-flex>
                            <v-flex xs7 sm7 md6 pl-2>
                                <v-text-field   v-model="empName"   clearable></v-text-field>
                            </v-flex>
                        </v-flex>


                        <v-flex row wrap xs12 sm12 md12 >
                            <v-flex xs5 sm5 md6 text-right  class="labelFont">
                                <v-label >科別代號</v-label>
                            </v-flex>
                            <v-flex xs7 sm7 md6 pl-2>
                                <v-autocomplete
                                        :disabled="this.editIndex!=-1"
                                        v-model="divNo"
                                        hide-details
                                        :items="divNoList"
                                        :item-text="divItemText"
                                        item-value="divNo"
                                ></v-autocomplete>
                            </v-flex>
                        </v-flex>



                        <v-flex row wrap xs12 sm12 md12>
                            <v-flex xs5 sm5 md6 text-right  class="labelFont">
                                <v-label >院區代號</v-label>
                            </v-flex>
                            <v-flex xs7 sm7 md6 pl-2>
                                <v-select
                                        v-if="zoneNameList.length>0"
                                        multiple
                                        v-model="zone"
                                        hide-details
                                        :items="zoneNameList"
                                        :item-text="zoneItemText"
                                        item-value="zone"
                                ></v-select>
                                <v-text-field v-else  v-model="zone"   clearable></v-text-field>
                            </v-flex>
                        </v-flex>

                    </v-flex>

                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >員工職稱抬頭</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9  >
                            <v-text-field   v-model="empTitlename"   clearable></v-text-field>
                        </v-flex>

                    </v-flex>



                    <v-flex row warp xs12 sm12 md12 >
                        <v-flex xs5 sm5 md3 text-center  class="labelFont">
                            <v-label >停止使用日期</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md9 pl-2 mt-3 >
                            <input style="border:1px solid black" id="inputDate" type="date" >
                            <v-btn  title="清除日期" icon  @click.native.stop="clearDate">
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-flex>





                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >人員介紹</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <!--<quill-editor v-model="empDoc"></quill-editor>-->
                            <!--<el-tiptap-custom :value.sync="empDoc"></el-tiptap-custom>-->
                            <v-textarea  filled rows="4" auto-grow :value="empDoc"  v-model="empDoc"  clearable ></v-textarea>

                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs3 sm3 md2 text-right  class="labelFont">
                            <v-label >人員經歷</v-label>
                        </v-flex>
                        <v-flex xs9 sm9 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="empExper"  v-model="empExper"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-card>
</template>

<script>
    // import ElTiptapCustom from './ElTiptapCustom'
    export default {
        name: "EditDoctor",
        // components: {ElTiptapCustom},
        props:['editIndex','isShow','editObj','isCopy','copyObj'],
        data() {
            return {
                snTimeout:4000,
                snStatus:false,
                snText:'',
                empNo:'',//員工編號
                empName:'',//員工姓名
                divNo:'',//科別代號
                zone:'',//院區代號
                empImage:'',//影像
                empDoc:'',//人員介紹
                empExper:'',//人員經歷
                stopEffDate:'',//停止使用日期
                empTitlename:'',//員工職稱抬頭
                displaySeq:'',//排序
                modifyObj:{},
                zoneNameList:[],
                divNoList:[],
            }
        },
        created(){
            this.axios_getZoneNameALL();
            this.axios_getDivNoList();

        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){

                    this.empNo = this.editObj.empNo==undefined?'':this.editObj.empNo;
                    this.empName = this.editObj.empName==undefined?'':this.editObj.empName;
                    this.divNo = this.editObj.divNo==undefined?'':this.editObj.divNo;
                    this.zone = this.editObj.zone==undefined?'':this.editObj.zone;
                    this.zone = typeof this.zone=="string"?this.zone.split(','):this.zone;
                    this.empImage = this.editObj.empImage==undefined?'':this.editObj.empImage;
                    this.empDoc = this.editObj.empDoc==undefined?'':this.editObj.empDoc;
                    this.empExper = this.editObj.empExper==undefined?'':this.editObj.empExper;
                    this.empTitlename = this.editObj.empTitlename==undefined?'':this.editObj.empTitlename;
                    this.stopEffDate = this.editObj.stopEffDate==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.editObj.stopEffDate,'date');
                    document.getElementById("inputDate").value = this.stopEffDate;
                    this.displaySeq = this.editObj.displaySeq==undefined?'':this.editObj.displaySeq;

                }else {
                    if(this.isCopy==true){
                        this.empNo = this.copyObj.empNo==undefined?'':this.copyObj.empNo;
                        this.empName = this.copyObj.empName==undefined?'':this.copyObj.empName;
                        this.divNo = this.copyObj.divNo==undefined?'':this.copyObj.divNo;
                        this.zone = this.copyObj.zone==undefined?'':this.copyObj.zone;
                        this.zone = typeof this.zone=="string"?this.zone.split(','):this.zone;
                        this.empImage = this.copyObj.empImage==undefined?'':this.copyObj.empImage;
                        this.empDoc = this.copyObj.empDoc==undefined?'':this.copyObj.empDoc;
                        this.empExper = this.copyObj.empExper==undefined?'':this.copyObj.empExper;
                        this.empTitlename = this.copyObj.empTitlename==undefined?'':this.copyObj.empTitlename;
                        this.stopEffDate = this.copyObj.stopEffDate==undefined?'':this.$UtilityJs.AD2ROC_DateTime(this.copyObj.stopEffDate,'date');
                        document.getElementById("inputDate").value = this.stopEffDate;
                        this.displaySeq = this.copyObj.displaySeq==undefined?'':this.copyObj.displaySeq;
                    }else {
                        // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                        this.empNo = '';
                        this.empName = '';
                        this.divNo = '';
                        this.zone = ['A']
                        this.empImage = '';
                        this.empDoc = '';
                        this.empExper = '';
                        this.empTitlename = '';
                        this.stopEffDate = null;
                        let  img = document.getElementById('image1');
                        img.setAttribute('src', '');
                        this.displaySeq = 0
                    }

                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 醫師簡介' : '編輯 醫師簡介'
            },
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            isDivEmp(divNo){
                return this.divNoList.filter((item) => {
                    if(divNo!==""){
                        return (item.divNo.indexOf(divNo) >= 0);
                    }else {
                        return [];
                    }

                });
            },
            getDoctorInfo(){
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "vdoctor/datasearch/bydoctorno/"+zone+"/"+this.empNo;
                this.$http.get(url).then(response=>{

                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.divNo = response.data.resultSet[0].divNo;
                      if(this.isDivEmp(this.divNo).length>0){
                          this.snStatus=true;
                          this.empName = response.data.resultSet[0].doctorName;
                          this.divNo = response.data.resultSet[0].divNo;
                          this.snText = response.data.message;
                      }else {
                          this.empName = response.data.resultSet[0].doctorName;
                          this.divNo = "";
                      }
                    }else {
                        this.snStatus=true;
                        this.empName = "";
                        this.divNo = "";
                        this.snText = "查無資料";

                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            clearDate(){
                document.getElementById("inputDate").value = null;
            },
            deleteImgIcon(){
                let  img = document.getElementById('image1');
                img.setAttribute('src', '');
            } ,
            pickImage(){
                let inputEl = document.getElementById('iptImage1');
                let imgEl = document.getElementById('image1');
                if (inputEl.files && inputEl.files[0]) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        imgEl.setAttribute('src', e.target.result);
                    };
                    reader.readAsDataURL(inputEl.files[0]);
                }
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                let  img = document.getElementById('image1');
                let imgsrc = img.getAttribute('src');

                if(this.empNo==''||this.empName==''||this.divNo==''){
                    alert('請輸入員工編號 和 員工姓名 以及 選擇科別')
                }else {
                    let stopEffDate = document.getElementById("inputDate").value;
                    this.modifyObj = {
                        displaySeq : this.displaySeq==''||this.displaySeq==null||this.displaySeq==undefined?0:this.displaySeq,
                        empNo : this.empNo,
                        empName : this.empName ,
                        divNo: this.divNo,
                        zone: this.zone.toString(),
                        empImage : imgsrc,
                        empDoc : this.empDoc ,
                        empExper: this.empExper,
                        empTitlename: this.empTitlename,
                        stopEffDate: stopEffDate==null||stopEffDate==''?null:new Date(stopEffDate+" 00:00:00").toJSON(),

                    }
                    this.$emit('save',this.modifyObj);
                }

            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
            axios_getDivNoList(){ //取得科別清單
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                // url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/telandsubdiv/"+zone;
                url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/divsionall/"+zone; //抓出全部科別

                this.$http.get(url).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.divNoList = response.data.resultSet;
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }

    .custom-file-input {
        color: transparent;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 36px;
        /*min-height: 30px;*/
        /*max-height: 30px;*/
        vertical-align: middle;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        letter-spacing: 0.1em;
        content: '+人員影像';
        color: black;
        display: inline-block;
        background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
        border: 1px solid #999;
        border-radius: 15px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-shadow: 1px 1px #fff;
        font-weight: 700;
        /*font-size: 10pt;*/
    }
    .custom-file-input:hover::before {
        border-color: black;
    }
    .custom-file-input:active {
        outline: 0;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }




</style>